import { Dispatch, Action } from 'redux'
import { TaskStatusButtonListMapDispatchReturnType } from './types/TaskStatusButtonListMapDispatchReturnType'

export const TaskStatusButtonListMapDispatch = (
  _dispatch: Dispatch<Action>
): TaskStatusButtonListMapDispatchReturnType => {
  return {}
}
